export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/sketch.e7c369a.png";